import { render } from "./spots.vue?vue&type=template&id=0df0e919"
import script from "./spots.vue?vue&type=script&lang=js"
export * from "./spots.vue?vue&type=script&lang=js"

import "./spots.vue?vue&type=style&index=0&id=0df0e919&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__